import type { Category, DisplayCategory, GiftCardCategory } from "./enums";
import type { SkuType } from "./Sku";
import { z } from "zod";

export type FavoriteOperatorType = {
   operatorId: number;
   countryCode: string;
}

export type ProductGraphType = {
   countryCode: string;
   recipientCountries: string[],
   operatorId: number;
   displayCategory: DisplayCategory,
   giftCardCategory: GiftCardCategory;
}

export type ProductType = {
   productId: number;
   productName: string;
   countryCode: string;
   disclaimer: string;
   operatorId: number;
	isVariable:  boolean;
   salesTax: number;
   category: Category;
   giftCardCategory: GiftCardCategory;
   skus: SkuType[];
};

export type OperatorType = {
   operatorId: number;
   operatorName: string;
   fileName?: string;
   discriminator?: string;
   slug: string;
   products: ProductType[];
};

export type Money = {
   currencyCode: string;
   amount: number;
};

export const amountSchema = z.object({
   currencyCode: z.string(),
   faceValue: z.number(),
   trxAmount: z.number(),
});

export type Amount = z.infer<typeof amountSchema>;

// export type Amount = {
//    currencyCode: string;
//    faceValue: number;
//    trxAmount: number;
// };

export type IpLocation = {
   countryCode: string;
   countryName: string;
   currencyCode: string;
};

export type JwtToken = {
   accessToken: string;
   expiresIn: number;
   tokenType: "Bearer" | "Bearer.TwoFactorUserId";
   refreshToken: string;
};
export type Jwt = {
	amr?: string;
	iss?: string;
	sub?: string;
	aud?: string[] | string;
	exp?: number;
	nbf?: number;
	iat?: number;
	jti?: string;
	"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier": string;
	"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": string;
	"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress": string;
	"http://schemas.microsoft.com/ws/2008/06/identity/claims/authenticationmethod"? : "Google" | "Facebook";
	"name": string,
  	"email-confirmed"?: "True",
	consent?: "True",
	resetOnNextLogin?: "true" | "false",
	"home-currency": string | undefined,
}

